<!-- PARTIAL PAYMENT -->
<app-receipt-paper *ngIf="!paidTotal()">
	<h3 class="" header>
		{{'ordersTotal' | translate}} {{ tableOrder.ordersPriceSum | formatFromCents | currency }}
	</h3>

	<div class="progressbar_content">
		<p class="green">{{'valuePaidNow' | translate}}: {{ valuePaid | formatFromCents | currency }}</p>

		<p class="text-success">
			<span *ngIf="tableOrder.remainingOrdersPrice >= 0">
				({{'remaining' | translate}} {{ tableOrder.remainingOrdersPrice | formatFromCents | currency }})
			</span>

			<span *ngIf="tableOrder.remainingOrdersPrice < 0">
				({{'extra' | translate}} {{ getPaymentExtra | formatFromCents | currency }})
			</span>
		</p>
	</div>

	<app-progress-bar
		percentage="{{
			calcPercentage(tableOrder.ordersPriceSum, tableOrder.ordersPriceSum - tableOrder.remainingOrdersPrice)
		}}"
	></app-progress-bar>
</app-receipt-paper>

<!-- TOTAL PAYMENT -->
<app-receipt-paper *ngIf="paidTotal()">
	<div class="customer">
		<div class="name">{{ user.name }}</div>

		<span class="status">
			<tg-badge text="{{'status.paid' | translate}}" backgroundColor="var(--green-mid)"></tg-badge>
		</span>
	</div>

	<div class="time">
		{{ lastPaymentFromUser.date | date: 'dd/MM/YYYY - hh:mm' }}
	</div>

	<div class="total">
		<div class="label">{{'totalPaid' | translate}}</div>

		<div class="value">{{ myOrdersValuePaid | formatFromCents | currency }}</div>
	</div>
</app-receipt-paper>
